export const Loading = () => {
  return (
    <div className="preload preload-container">
      <div className="preload-logo">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export const LoadingDiv = () => {
  return <div className="spinnerInner"></div>;
};

export const LoadingButton = () => {
  return (
    <div className="loadIcon" id="loadIcon">
      <div className="load"></div>
    </div>
  );
};
